"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.infoAuthorizaUrl = exports.formItemInfo = exports.privacyAdd = void 0;
/**
 * 隐私协议地址
 */
var privacyAdd = {
    m: '//m.58che.com/home.php?c=Dealer_AskPrice&a=Privacy',
    app: '//appsm.58che.com/58/privacy.html',
};
exports.privacyAdd = privacyAdd;
/** 个人信息授权书地址 */
var infoAuthorizaUrl = 'https://appsm.58che.com/58/authorizebook.html';
exports.infoAuthorizaUrl = infoAuthorizaUrl;
var baseInfo = {
    cn: 'input-wrap',
    inputCN: '',
};
/**
 * 总共内置 姓名 / 电话 / 验证码 / 隐私协议
 * 默认存在的有姓名/电话
 */
var formItemInfo = {
    name: {
        ruleData: {
            id: "name" /* 姓名 */,
            require: true,
            rule: 'empty',
        },
        autoConfig: __assign({ labelStr: '称呼', placeholder: '请输入您的称呼' }, baseInfo),
    },
    tel: {
        ruleData: {
            id: "tel" /* 电话 */,
            require: true,
            rule: 'empty,tel',
        },
        autoConfig: __assign({ labelStr: '电话', placeholder: '请输入您的手机号' }, baseInfo),
    },
    code: {
        ruleData: {
            id: "code" /* 验证码 */,
            require: true,
            rule: 'empty',
        },
        autoConfig: __assign({ labelStr: '验证码', placeholder: '请输入验证码' }, baseInfo),
    },
    privacy: {
        ruleData: {
            id: "privacy" /* 隐私协议 */,
            require: true,
            rule: 'radio',
        },
    },
};
exports.formItemInfo = formItemInfo;
